import { __decorate } from "tslib";
import { ArrayDecoder, AutoEncoder, field, IntegerDecoder, StringDecoder } from '@common/encoding';
export class StockReservation extends AutoEncoder {
    objectId;
    /**
     * To identify for what object type this reservation happened.
     *
     * E.g. 'productPrice'
     */
    objectType;
    amount = 0;
    children = [];
    static getAmount(type, id, list) {
        let amount = 0;
        for (const reservation of list) {
            if (reservation.objectType === type && (id === null || reservation.objectId === id)) {
                amount += reservation.amount;
            }
        }
        return amount;
    }
    static filter(type, id, list) {
        return list.filter(r => r.objectType === type && r.objectId === id).flatMap(r => r.children);
    }
    static add(base, add) {
        const existingIndex = base.findIndex(r => r.objectType === add.objectType && r.objectId === add.objectId);
        if (existingIndex !== -1) {
            const existing = base[existingIndex];
            existing.amount += add.amount;
            existing.children = StockReservation.added(existing.children, add.children);
            if (existing.amount == 0 && existing.children.length === 0) {
                // NOTE: the amount should be zero.
                // if it is negative, we still have to keep it, because it can be needed during a calculation
                base.splice(existingIndex, 1);
                return;
            }
        }
        else {
            base.push(add.clone());
        }
    }
    invert() {
        this.amount = -this.amount;
        for (const child of this.children) {
            child.invert();
        }
    }
    static remove(base, remove) {
        const c = remove.clone();
        c.invert();
        return this.add(base, c);
    }
    static added(base, add) {
        const newReservations = [];
        for (const r of base) {
            // We do this because it is possible that base contains errors or duplicates
            this.add(newReservations, r);
        }
        for (const r of add) {
            this.add(newReservations, r);
        }
        return newReservations;
    }
    static removed(base, remove) {
        const newReservations = [];
        for (const r of base) {
            // We do this because it is possible that base contains errors or duplicates
            this.add(newReservations, r);
        }
        for (const r of remove) {
            this.remove(newReservations, r);
        }
        return newReservations;
    }
}
__decorate([
    field({ decoder: StringDecoder, field: 'id' })
], StockReservation.prototype, "objectId", void 0);
__decorate([
    field({ decoder: StringDecoder, field: 't' })
], StockReservation.prototype, "objectType", void 0);
__decorate([
    field({ decoder: IntegerDecoder, field: 'a' })
], StockReservation.prototype, "amount", void 0);
__decorate([
    field({ decoder: new ArrayDecoder(StockReservation), field: 'c' })
], StockReservation.prototype, "children", void 0);
//# sourceMappingURL=StockReservation.js.map